export const INIT_GEO_DATASET = 'INIT_GEO_DATASET';
export const ADD_DS_GEO = 'ADD_DS_GEO';
export const CHANGE_DS_GEO = 'CHANGE_DS_GEO';
export const DEL_DS_GEO = 'DEL_DS_GEO';
export const CHANGE_SELROW_GEO = 'CHANGE_SELROW_GEO';
export const CHANGE_NAME_GEO = 'CHANGE_NAME_GEO';
export const CHANGE_GEO_GEO = 'CHANGE_GEO_GEO';
export const ADD_GEO_GEO = 'ADD_GEO_GEO';
export const DEL_GEO_GEO = 'DEL_GEO_GEO';
export const ISDEL_GEO = 'ISDEL_GEO';
export const RESET_GEO_GEO = 'RESET_GEO_GEO';


export function initDsAction(data) {
    return {
        type: INIT_GEO_DATASET,
        data: data
    };
}

export function addDsAction(data) {
    return {
        type: ADD_DS_GEO,
        data: data
    };
}

export function changeDsAction(data) {
    return {
        type: CHANGE_DS_GEO,
        data: data
    };
}

export function delDsAction(rowID) {
    return {
        type: DEL_DS_GEO,
        rowID: rowID
    };
}

export function changeSelRowAction(rowID) {
    return {
        type: CHANGE_SELROW_GEO,
        rowID: rowID
    };
}

export function changeNameAction(name) {
    return {
        type: CHANGE_NAME_GEO,
        name: name
    };
}

export function changeGeoAction(geo) {
    return {
        type: CHANGE_GEO_GEO,
        geo: geo
    };
}

export function addGeoAction(ID) {
    return {
        type: ADD_GEO_GEO,
        ID: ID
    };
}

export function delGeoAction(rowID) {
    return {
        type: DEL_GEO_GEO,
        rowID: rowID
    };
}

export function isDelAction(isDel) {
    return {
        type: ISDEL_GEO,
        isDel: isDel
    };
}

export function resetGeoAction() {
    return {
        type: RESET_GEO_GEO,
    };
}